import { type TeamState } from 'team/types.js'

export const messages = (state: TeamState) => state.messages
